import React, { useState, useEffect } from "react";
import { Button, Input, Message } from "semantic-ui-react";
import { ModalConfirm } from "../../../Common";
import { VOID_REASONS, getPaymentMethod } from "../../../../utils/constants";
import { getTableLabel } from "../../../../utils/table";
import "./VoidPaymentModal.scss";

// "Anular venta" (Historial de Pagos, solo Admin/Súper Usuario): motivo
// obligatorio. La venta no se borra — pasa a VOID, deja de sumar en reportes
// y en el efectivo esperado de la Caja abierta, y queda en Reportes →
// Anulaciones con quién, cuándo y por qué.
export function VoidPaymentModal(props) {
  const { payment, onClose, onConfirm } = props;
  const [reason, setReason] = useState(null);
  const [note, setNote] = useState("");
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setReason(null);
    setNote("");
    setError(null);
  }, [payment]);

  if (!payment) return null;

  const fullReason = note.trim() ? `${reason} — ${note.trim()}` : reason;
  const needsNote = reason === "Otro" && !note.trim();

  const confirm = async () => {
    setSaving(true);
    setError(null);
    try {
      await onConfirm(payment, fullReason);
    } catch (err) {
      setError("No se pudo anular la venta. Revisa tu conexión o tus permisos.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalConfirm
      show
      size="tiny"
      title="¿Anular esta venta?"
      content={
        <div className="void-payment-modal">
          <p>
            Mesa <strong>{getTableLabel(payment)}</strong> · S/{" "}
            {payment.totalPayment} · {getPaymentMethod(payment.paymentType)?.text}
          </p>
          <Message info size="small" className="void-payment-modal__info">
            <p>
              <strong>Úsalo para corregir un cobro mal registrado:</strong> cobro
              duplicado, monto o forma de pago equivocados, o una devolución al
              cliente.
            </p>
            <ul>
              <li>
                La venta <strong>no se borra</strong>: deja de contar en las
                ventas, los reportes y el efectivo esperado de la caja abierta
                (una caja ya cerrada no cambia).
              </li>
              <li>
                <strong>No devuelve el dinero</strong>: la devolución en Yape,
                Plin o el POS de tarjeta se hace aparte.
              </li>
              <li>
                Queda registrado quién la anuló, cuándo y por qué (Reportes →
                Anulaciones).
              </li>
            </ul>
          </Message>
          <p className="void-payment-modal__warning">No se puede deshacer.</p>
          <div className="void-payment-modal__reasons">
            {VOID_REASONS.map((text) => (
              <Button
                key={text}
                type="button"
                basic={reason !== text}
                color={reason === text ? "red" : undefined}
                onClick={() => setReason(text)}
              >
                {text}
              </Button>
            ))}
          </div>
          {reason && (
            <Input
              fluid
              placeholder={reason === "Otro" ? "Explica el motivo" : "Detalle (opcional)"}
              value={note}
              maxLength={200}
              onChange={(_, data) => setNote(data.value)}
            />
          )}
          {error && <Message negative size="small">{error}</Message>}
        </div>
      }
      onClose={onClose}
      onCloseText="Volver"
      onConfirm={confirm}
      onConfirmText={saving ? "Anulando…" : "Sí, anular venta"}
      confirmDisabled={!reason || needsNote || saving}
    />
  );
}
